import { Preferences } from '@capacitor/preferences';

const KEY = 'pk.token';
/** sessionStorage flag set right before we redirect to Codai; main.tsx only accepts `#token=` when it is present. */
export const CODAI_PENDING_KEY = 'pk.codaiPending';
let cached: string | null = null;
const listeners = new Set<(t: string | null) => void>();

/** Load the persisted token into memory (call once before rendering). */
export async function loadToken(): Promise<string | null> {
  try {
    const { value } = await Preferences.get({ key: KEY });
    cached = value ?? null;
  } catch {
    cached = null;
  }
  return cached;
}

export function getToken(): string | null {
  return cached;
}

export async function setToken(token: string | null): Promise<void> {
  cached = token;
  try {
    if (token) await Preferences.set({ key: KEY, value: token });
    else await Preferences.remove({ key: KEY });
  } catch {
    /* storage unavailable: in-memory only */
  }
  listeners.forEach((l) => l(token));
}

export function onTokenChange(fn: (t: string | null) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
